<template>
    <div>
        <p class="mt-3 mb-3">
            All products must have Boxiti system stickers with barcodes. Each product must be with only one barcode
            provided by Boxiti (all other existing stickers and barcodes must be hidden or removed). You can print stickers on this page.
        </p>
        <div class="d-flex justify-content-center h-50 align-items-center" v-if="$store.state.loading">
            <b-spinner variant="info" style="width: 7rem; height: 7rem;"/>
        </div>
        <div v-else class="d-flex justify-content-center align-items-center mt-auto mb-auto">
            <b-form-select class="w-25"
                           :options="options"
                           :value="null"
                           size="sm"
                           v-model="selected"/>
            <slot name="quantity"/>
            <b-btn variant="primary-user"
                   class="ml-2"
                   size="sm"
                   :disabled="btnDisabled" @click="emitData">Print stickers</b-btn>
            <slot name="next"/>
        </div>
    </div>
</template>

<script>
    import options from '@/assets/js/print-options'

    export default {
        name: 'PrintLabels',
        props: ['quantity'],
        data() {
            return {
                options: options,
                selected: null,
                quantityStickers: 0
            }
        },
        computed: {
            btnDisabled() {
                return this.$slots.quantity ? !this.quantity || !this.selected : !this.selected
            }
        },
        methods: {
            emitData() {
                let quantity = this.quantity
                this.$emit('print', {quantity, ...this.selected})
            }
        }
    }
</script>

<style lang="scss" scoped>
    p   {
        font-weight: 600;
        font-size: 14px;
    }
</style>



// WEBPACK FOOTER //
// src/components/UserPanel/Elements/PrintLabels.vue